module.exports = __webpack_public_path__ + "img/video-recorder.5cfafaf1.svg";